import type SvgIcon from 'LuxKit/SvgIcon'
import ListItemThumbnail from 'LuxKit/List/ListItemThumbnail'
import BodyText from 'LuxKit/Typography/BodyText'
import Heading from 'LuxKit/Typography/Heading'
import Group from 'components/utils/Group'
import { rem } from 'polished'
import type { ReactNode } from 'react'
import styled from 'styled-components'

const Card = styled(Group)`
  border-radius: ${props => props.theme.borderRadius.S};
  border: 1px solid ${props => props.theme.palette.neutral.default.six};
  box-shadow: ${props => props.theme.shadow.flat.small};
  padding: ${rem(32)} ${rem(36)};
`

const IconThumbnail = styled(ListItemThumbnail)`
  border-radius: ${props => props.theme.borderRadius.round};
  flex-shrink: 0;
`

const ActionContainer = styled.div`
  flex-shrink: 0;
`

interface Props {
  heading: ReactNode
  description: ReactNode
  action?: ReactNode
  Icon: typeof SvgIcon
}

function AdditionalWaysToExperienceMessagingTile({ heading, description, action, Icon }: Props) {
  return <Card direction="vertical" tabletDirection="horizontal" gap={20} verticalAlign="center" horizontalAlign="space-between">
    <Group direction="horizontal" gap={16} verticalAlign="center">
      <IconThumbnail kind="highlight-secondary">
        <Icon size="S" />
      </IconThumbnail>
      <Group direction="vertical" gap={4}>
        <Heading variant="heading4">{heading}</Heading>
        <BodyText variant="medium" colour="light-foreground-alt">{description}</BodyText>
      </Group>
    </Group>
    {!!action && <ActionContainer>{action}</ActionContainer>}
  </Card>
}

export default AdditionalWaysToExperienceMessagingTile
